"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Tree = _interopRequireDefault(require("./Tree"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _link = _interopRequireDefault(require("cccisd-icons/link"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _Metrics = _interopRequireDefault(require("./Metrics"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Picker = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Picker, _React$Component);
  function Picker(props) {
    var _this;
    _classCallCheck(this, Picker);
    _this = _callSuper(this, Picker, [props]);
    _defineProperty(_assertThisInitialized(_this), "selectDataConnector", function (obj) {
      if (!(0, _isEqual2["default"])(_this.state.selectedDataConnector, obj)) {
        _this.setState({
          selectedDataConnector: obj
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDelete", function () {
      _this.props.field.onChange(null);
      _this.props.afterChange();
    });
    _defineProperty(_assertThisInitialized(_this), "handlePicking", function () {
      _this.props.field.onChange(_objectSpread({
        instance: 'dataConnector'
      }, _this.state.selectedDataConnector));
      _this.props.afterChange();
      if (_this.refs.modal) {
        _this.refs.modal.close();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getFilter", function () {
      var type = _this.props.type;
      if (!(0, _isArray2["default"])(type)) {
        type = [type];
      }
      if (type.length === 0) {
        return null;
      }
      return function (node, parent) {
        if (!node.disabled && !node.isAdult && !type.includes(node.type)) {
          return false;
        }
        return (0, _omit2["default"])(node, ['children']);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getNameWithTypes", function () {
      var _this$props = _this.props,
        type = _this$props.type,
        name = _this$props.name;
      return name + '_' + ((0, _isArray2["default"])(type) ? type.join('_') : type);
    });
    _this.state = {
      selectedDataConnector: props.field.value,
      currentTabName: props.field.value && props.field.value.category === 'metrics' ? 'metrics' : 'flow'
    };
    return _this;
  }
  _createClass(Picker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        field = _this$props2.field,
        label = _this$props2.label,
        comment = _this$props2.comment,
        noModal = _this$props2.noModal,
        topRender = _this$props2.topRender,
        wrapperClassName = _this$props2.wrapperClassName;
      var tabs = [{
        name: 'flow',
        label: 'Survey',
        component: /*#__PURE__*/_react["default"].createElement(_Tree["default"], {
          name: this.getNameWithTypes(),
          selectedDataConnector: this.state.selectedDataConnector,
          onSelect: this.selectDataConnector,
          handlePicking: this.handlePicking,
          filter: this.getFilter()
        })
      }, {
        name: 'metrics',
        label: 'Metrics',
        component: /*#__PURE__*/_react["default"].createElement(_Metrics["default"], {
          selectedDataConnector: this.state.selectedDataConnector,
          onSelect: this.selectDataConnector,
          handlePicking: this.handlePicking,
          filter: this.getFilter()
        })
      }];
      var currentTab = tabs.find(function (tab) {
        return tab.name === _this2.state.currentTabName;
      });
      var modalBody = /*#__PURE__*/_react["default"].createElement("div", null, topRender, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "nav nav-tabs",
        style: {
          marginBottom: '1em'
        }
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: tab.name,
          className: "nav-item"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.setState({
              currentTabName: tab.name
            });
          },
          className: (0, _classnames["default"])('nav-link', tab.name === _this2.state.currentTabName && 'active')
        }, tab.label));
      })), currentTab.component);
      if (noModal) {
        return modalBody;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: field,
        label: label,
        comment: comment,
        wrapperClassName: wrapperClassName
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '-2px'
        }
      }, field.value ? field.value.title || 'picked' : 'none', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: "modal",
        title: "Pick data connector",
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: _style["default"].button + ' btn btn-xs btn-secondary',
          title: "Link data connector"
        }, /*#__PURE__*/_react["default"].createElement(_link["default"], null)),
        size: "large",
        afterClose: function afterClose() {
          // reset state value
          _this2.setState({
            selectedDataConnector: _this2.props.field.value
          });
        }
      }, modalBody), field.value && /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-secondary text-danger",
        title: "Delete data connector",
        style: {
          marginLeft: '.2em'
        },
        onClick: this.onDelete
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))));
    }
  }]);
  return Picker;
}(_react["default"].Component);
_defineProperty(Picker, "propTypes", {
  name: _propTypes["default"].string,
  field: _propTypes["default"].object.isRequired,
  label: _propTypes["default"].node,
  comment: _propTypes["default"].node,
  type: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]).isRequired,
  afterChange: _propTypes["default"].func,
  noModal: _propTypes["default"].bool,
  topRender: _propTypes["default"].node,
  wrapperClassName: _propTypes["default"].string
});
_defineProperty(Picker, "defaultProps", {
  name: 'tree',
  label: 'Data connector',
  afterChange: function afterChange() {},
  noModal: false
});